export default __webpack_public_path__ + "static/media/lottery-random-lunabulls.06adeffd.png";